module.exports = __webpack_public_path__ + "assets/fonts/source-han-sans-cn-normal.4bf258e4.otf";